import {auth} from "@/state/auth.js"

function make_query(obj) {
  let str = [];
  for (let p in obj)
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      let val = obj[p];
      if (typeof val == 'object') val = JSON.stringify(val)
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(val));
    }
  return str.join("&");
}

const http = {
  api: '/api',

  async request({path, method, query, body, formdata}) {

    const token = await auth?.getToken();

    const headers = token ? {
      'Authorization': 'Bearer ' + token
    } : {}

    const query_str = query ? '?' + make_query(query) : '';
    const url = this.api + path + query_str;

    let request;

    if (formdata) {
      const formdata_ = new FormData();

      for (const k in formdata) formdata_.append(k, formdata[k])

      request = {
        method: method,
        headers: {
          ...headers
        },
        body: formdata_
      }
    } else {
      const body_ = body ? {body: JSON.stringify(body)} : {};

      request = {
        method: method,
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        },
        ...body_
      }
    }


    const resp = await fetch(url, request);

    if (!resp.ok) {
      const text = await resp.text();
      // console.log("Got " + resp.status + " error (" + text + ") while " + method + " " + url)
      let error = '';
      try {
        error = JSON.parse(text).detail;
        if (typeof error !== "string") error = text;
      } catch (e) {
        error = text;
      }
      throw Error(error);
    }

    if (resp.status == 204) return;

    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      console.error("Error parsing json in response", text);
      throw e;
    }

  },

  async get(path, query) {
    return await this.request({
      method: 'GET',
      path: path,
      query: query,
    });
  },

  async getBlob(path, query) {
    return await this.request({
      method: 'GET',
      path: path,
      query: query,
      response: 'blob'
    });
  },

  async post(path, data) {
    return await this.request({
      method: 'POST',
      path: path,
      body: data
    })
  },

  async post_form(path, formdata) {
    return await this.request({
      method: 'POST',
      path: path,
      formdata
    })
  },

  async put(path, data) {
    return await this.request({
      method: 'PUT',
      path: path,
      body: data
    })
  },

  async patch(path, data) {
    return await this.request({
      method: 'PATCH',
      path: path,
      body: data
    })
  },

  async delete(path, query) {
    return await this.request({
      method: 'DELETE',
      path: path,
      query: query
    })
  },

}

export {
  http, make_query
}